(function () {
  const sections = document.querySelectorAll('[data-quiz-section]');
  if (!sections.length) return;

  sections.forEach((root) => {
    const sid = root.id.replace('quiz-', '');
    const defaultCatName = root.dataset.defaultName || 'Luna';
    const byId = (id) => document.getElementById(id + '-' + sid);

    const revObs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, i) => {
          if (!entry.isIntersecting) return;
          setTimeout(() => entry.target.classList.add('on'), i * 55);
          revObs.unobserve(entry.target);
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );
    root.querySelectorAll('.reveal-up').forEach((el) => revObs.observe(el));

    const cursor = byId('fakeCursor');
    const ripple = byId('cursorRipple');
    const progress = byId('qProgress');
    const nameInp = byId('nameInput');
    const ageInp = byId('ageInput');

    function sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    }

    function moveCursor(x, y, ms = 650) {
      return new Promise((resolve) => {
        cursor.style.transition = 'left ' + ms + 'ms cubic-bezier(.25,.1,.25,1), top ' + ms + 'ms cubic-bezier(.25,.1,.25,1)';
        cursor.style.left = x + 'px';
        cursor.style.top = y + 'px';
        setTimeout(resolve, ms);
      });
    }

    function clickAt(x, y) {
      return new Promise((resolve) => {
        ripple.style.left = x + 'px';
        ripple.style.top = y + 'px';
        ripple.style.animation = 'none';
        void ripple.offsetWidth;
        ripple.style.animation = 'rippleClick .5s ease forwards';
        setTimeout(resolve, 520);
      });
    }

    function scrollDown() {
      const content = root.querySelector('.quiz-content');
      content.scrollTo({ top: content.scrollHeight, behavior: 'smooth' });
      return sleep(350);
    }

    function scrollToElement(el) {
      const content = root.querySelector('.quiz-content');
      const top = Math.max(0, el.offsetTop - 12);
      content.scrollTo({ top: top, behavior: 'smooth' });
      return sleep(350);
    }

    function show(id, withScroll) {
      const el = byId(id);
      el.classList.remove('hidden');
      if (withScroll) return sleep(420).then(() => scrollToElement(el));
      return sleep(420);
    }

    function pos(el) {
      const wrap = root.querySelector('.quiz-ui-side');
      const wr = wrap.getBoundingClientRect();
      const er = el.getBoundingClientRect();
      return { x: er.left - wr.left + er.width / 2, y: er.top - wr.top + er.height / 2 };
    }

    function updateName(name) {
      root.querySelectorAll('.cn').forEach((span) => {
        span.textContent = name;
      });
    }

    function typewriter(el, text, speed = 95) {
      return new Promise((resolve) => {
        let i = 0;
        el.value = '';
        const iv = setInterval(() => {
          el.value += text[i];
          updateName(text.slice(0, i + 1));
          i += 1;
          if (i >= text.length) {
            clearInterval(iv);
            resolve();
          }
        }, speed);
      });
    }

    function selectMonth(selectEl, value, ms = 600) {
      return new Promise(async (resolve) => {
        selectEl.classList.add('open');
        await sleep(ms);
        selectEl.value = value;
        await sleep(300);
        selectEl.classList.remove('open');
        resolve();
      });
    }

    async function resetAll() {
      ['qAge', 'qInfobox', 'qExactAge', 'qBirthday', 'qGender', 'qCastration', 'qRasse'].forEach((id) => {
        byId(id).classList.add('hidden');
      });
      ['pillAdult', 'pillWeiblich', 'pillKastriert', 'pillMischling'].forEach((id) => {
        byId(id).classList.remove('selected');
      });
      nameInp.value = '';
      ageInp.value = '';
      byId('monthSelect').value = '';
      progress.style.transition = 'width .3s ease';
      progress.style.width = '0%';
      setTimeout(() => {
        progress.style.transition = 'width 1s ease';
      }, 400);
      root.querySelector('.quiz-content').scrollTo({ top: 0, behavior: 'smooth' });
      updateName(defaultCatName);
      await sleep(500);
    }

    async function runSequence() {
      await sleep(700);

      cursor.style.opacity = '1';
      const nameP = pos(nameInp);
      cursor.style.transition = 'none';
      cursor.style.left = nameP.x - 80 + 'px';
      cursor.style.top = nameP.y + 30 + 'px';
      await sleep(150);

      progress.style.width = '14%';

      await moveCursor(nameP.x, nameP.y, 500);
      await clickAt(nameP.x, nameP.y);
      nameInp.style.borderColor = 'var(--purple)';
      await sleep(250);

      await typewriter(nameInp, defaultCatName, 100);
      await sleep(700);
      nameInp.style.borderColor = '';

      await show('qAge');
      await sleep(350);

      const adultP = pos(byId('pillAdult'));
      await moveCursor(adultP.x, adultP.y, 700);
      await clickAt(adultP.x, adultP.y);
      byId('pillAdult').classList.add('selected');
      progress.style.width = '28%';
      await sleep(300);

      await show('qInfobox');
      await sleep(200);
      await show('qExactAge');
      await sleep(500);

      const ageP = pos(ageInp);
      await moveCursor(ageP.x, ageP.y, 600);
      await clickAt(ageP.x, ageP.y);
      ageInp.classList.add('focused');
      await sleep(250);
      ageInp.value = '4';
      await sleep(550);
      ageInp.classList.remove('focused');
      progress.style.width = '42%';

      await show('qBirthday', true);
      await sleep(400);

      const sel = byId('monthSelect');
      const selP = pos(sel);
      await moveCursor(selP.x, selP.y, 650);
      await clickAt(selP.x, selP.y);
      await selectMonth(sel, 'Juni', 700);
      await sleep(400);

      await show('qGender', true);
      await sleep(400);
      progress.style.width = '56%';

      const weibP = pos(byId('pillWeiblich'));
      await moveCursor(weibP.x, weibP.y, 700);
      await clickAt(weibP.x, weibP.y);
      byId('pillWeiblich').classList.add('selected');
      await sleep(350);

      await show('qCastration', true);
      await sleep(400);
      progress.style.width = '70%';

      const kastP = pos(byId('pillKastriert'));
      await moveCursor(kastP.x, kastP.y, 700);
      await clickAt(kastP.x, kastP.y);
      byId('pillKastriert').classList.add('selected');
      await sleep(400);

      await show('qRasse', true);
      await sleep(400);
      progress.style.width = '84%';

      const mischP = pos(byId('pillMischling'));
      await moveCursor(mischP.x, mischP.y, 700);
      await clickAt(mischP.x, mischP.y);
      byId('pillMischling').classList.add('selected');
      await sleep(500);

      progress.style.width = '100%';

      const weiterP = pos(byId('weiterBtn'));
      await moveCursor(weiterP.x, weiterP.y, 600);
      await sleep(350);
      await clickAt(weiterP.x, weiterP.y);
      byId('weiterBtn').classList.add('clicked');
      await sleep(300);
      byId('weiterBtn').classList.remove('clicked');

      cursor.style.opacity = '0';
      await sleep(700);

      await resetAll();
      runSequence();
    }

    const startObs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          setTimeout(runSequence, 1000);
          startObs.unobserve(entry.target);
        });
      },
      { threshold: 0.3 }
    );
    startObs.observe(root);
  });
})();
